import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { withParams } from 'providers/ParamsConsumer';
import GroupContainerBase from './GroupContainerBase';
import { useDispatch } from 'react-redux';
import { saveBehaviorParams } from '../../../features/params/globalParams/actionCreators';

const ReorderComponentsContainer = ({ reorderComponentsName, defaultComponentsOrder, getComponent, getComponentExtraParams, params }) => {
  const [userComponentsOrder, setUserComponentsOrder] = useState({});
  const dispatch = useDispatch();
  const [isSaving, setIsSaving] = useState(false);
  const [reorderEnabled, setReorderEnabled] = useState(false);
  const disabled = useMemo(() => Boolean(!params.reorderComponents), [params.reorderComponents]);

  useEffect(() => {
    if (!params.reorderComponents) return;
    const fullObject = JSON.parse(params.reorderComponents);
    let tmpComponentsOrder = fullObject[reorderComponentsName];
    if (!tmpComponentsOrder) tmpComponentsOrder = {};

    setUserComponentsOrder(tmpComponentsOrder);
  }, [params.reorderComponents, reorderComponentsName]);

  const handleSave = newUserComponentsOrder => {
    let fullObject = JSON.parse(params.reorderComponents);
    fullObject[reorderComponentsName] = newUserComponentsOrder;
    const reorderComponentsAsString = JSON.stringify(fullObject);
    setIsSaving(true);
    dispatch(saveBehaviorParams('ReorderComponents', reorderComponentsAsString)).then(() => {
      setIsSaving(false);
      setReorderEnabled(false);
    });
  };

  return (
    <GroupContainerBase
      getComponent={getComponent}
      getComponentExtraParams={getComponentExtraParams}
      defaultComponentsOrder={defaultComponentsOrder}
      reorderComponentsName={reorderComponentsName}
      userComponentsOrder={userComponentsOrder}
      reorderEnabled={reorderEnabled}
      setReorderEnabled={setReorderEnabled}
      onSave={handleSave}
      isSaving={isSaving}
      disabled={disabled}
    />
  );
};

ReorderComponentsContainer.propTypes = {
  reorderComponentsName: PropTypes.string,
  defaultComponentsOrder: PropTypes.any,
  getComponent: PropTypes.func,
  getComponentExtraParams: PropTypes.any,
  params: PropTypes.object.isRequired
};

export default withParams(ReorderComponentsContainer);
